module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av603-4b74bbffef2aced06bdea3118fed5c85.jpg";